<template>
    <transition-group
        ref="root"
        class="horizontal-list"
        :tag="tag"
        name="horizontal-list"
        @before-leave="onBeforeLeave"
    >
        <li
            v-for="item, key in items"
            :key="`item-${item.id}-${key}`"
            class="item"
            v-bind="item.attr"
        >
            <nuxt-link
                class="desktop-main-nav-link"
                :to="item.url"
                :class="{
                    active: item.active,
                }"
            >
                {{ item.text }}
            </nuxt-link>
        </li>
    </transition-group>
</template>
<script setup>
import { ref } from '#imports';

const root = ref(null);

const props = defineProps({ // eslint-disable-line
    items: {
        type: Array,
        required: false,
        default: () => [],
    },
    tag: {
        type: String,
        required: false,
        default: 'ul',
    },
});

function onBeforeLeave(el) {
    const { position: parentPosition }= getComputedStyle(root.value.$el);
    const offsets = {};

    if (parentPosition !== 'static') {
        Object.assign(offsets, {
            left: `${el.getBoundingClientRect().x - root.value.$el.getBoundingClientRect().x}px`,
            top: `${el.getBoundingClientRect().y - root.value.$el.getBoundingClientRect().y}px`,
        });
    } else {
        Object.assign(offsets, {
            left: `${el.getBoundingClientRect().x}px`,
            top: `${el.getBoundingClientRect().y}px`,
        });
    }

    Object.assign(el.style, offsets);
}
</script>
<style scoped>
.horizontal-list {
  position: relative;
  list-style: none;
  display: flex;
  flex-flow: row nowrap;
  margin: 0;
  padding: 0;
}
.horizontal-list .item:not(:last-child) {
  margin-right: 1rem;
}

.horizontal-list-enter-active,
.horizontal-list-leave-active {
  transition: all 0.5s ease;
}

.horizontal-list-enter-from,
.horizontal-list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.horizontal-list-leave-to {
  position: absolute;
  transform: translateX(-30px);
}
</style>
